import React, { useState, useEffect } from 'react';
import { AppBar as MuiAppBar, Toolbar, IconButton, Menu, MenuItem, Typography, Box, Avatar } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../../assets/Alerta Normativa-logo2026-claro.png';
import { jwtDecode } from 'jwt-decode';
import NotificacionesMenu from './NotificacionMenu';
import NotificacionBandejaMenu from './NotificacionBandejaMenu';

const AppBar = ({ handleDrawerToggle, isOpen, toggleDrawer }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [userName, setUserName] = useState('');
    const [userLastName, setUserLastName] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserName(decoded["given_name"] || '');
                setUserLastName(decoded["family_name"] || '');
                setIsAdmin(decoded["rol"] === "Administrador");
            } catch (error) {
                console.error('Error decoding token:', error);
                // Manejar el error, posiblemente redirigiendo al login
                handleLogout();
            }
        } else {
            // No hay token, redirigir al login
            navigate('/login');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    const handlePerfilUsuario = () => {
        navigate('/perfil-usuario');
    };
    return (
        <MuiAppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: '#f8f9fa' }}>
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                        color="black"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <IconButton
                        color="black"
                        aria-label="toggle drawer"
                        edge="start"
                        onClick={toggleDrawer}
                        sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ display: { xs: 'none', sm: 'block'} }}>
                        <Link style={{ textDecoration: 'none', color: 'inherit' }} to="/home">
                            <img src={Logo} alt="Alerta Normativa" style={{ height: '50px', display: 'flex' }} />
                        </Link>
                    </Box>
                </Box>
                
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {isAdmin && <NotificacionBandejaMenu />} 
                    <NotificacionesMenu />
                    <Typography variant="body1" color="black" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}> {/* Oculta el nombre de usuario en pantallas extra pequeñas */}
                        Bienvenido/a {userName}
                    </Typography>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="black"
                    >
                        <Avatar sx={{ width: 40, height: 40}}>{userName[0]+(userLastName[0] || '')}</Avatar>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handlePerfilUsuario}>Perfil de Usuario</MenuItem>
                        <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </MuiAppBar>
    );
};

export default AppBar;